<template>
    <div class="picture_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">透明度</span>
            <el-input v-model="config.opacity" @change="getRender" type="number" step="0.1" :min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">面积占比</span>
            <el-input v-model="config.width" @change="getRender" type="number" step="1" :min="0" max="100"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.isClick" @change="getRender">允许点击</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">滚动条显示</span>
            <el-select v-model="config.scrolling" placeholder="请选择粗字号"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in scrollingList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig textViewConfig">
            <span class="span_til">网页地址</span>
            <el-input
                    class="text_input"
                    type="textarea"
                    autosize
                    size="mini"
                    placeholder="再此修改内容！"
                    v-model="config.src"
                    @change="getRender">
            </el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'picture_config',
        components: {},
        data() {
            return {
                scrollingList:[{name:'显示',value:'yes'},{name:'不显示',value:'no'},{name:'自动',value:'auto'}],
            }
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .picture_config {

    }
</style>
